import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState, selectLanguageInCommonState } from 'app/app-state.index';
import { BusinessManagmentService } from 'app/core/services/business-managment.service';
import { BusinessManagment, PackageDto } from 'app/public/model/BusinessManagment';
import { LocalizationService } from 'app/shared/localization/localization.service';
import { FieldTypes, Language, SourceEnum } from 'app/shared/model/enums';
import { CommonService } from 'app/shared/services/common.service';
import { BehaviorSubject, map, Observable, switchMapTo, tap } from 'rxjs';

@Component({
  selector: 'app-business-management',
  templateUrl: './business-management.component.html',
  styleUrl: './business-management.component.scss'
})
export class BusinessManagementComponent implements OnInit{
  
  request: { Paging: any;Filter:{FreeSearch:string,Package:PackageDto,BusinessSource:SourceEnum},Language:Language,SortField:string,SortOrder:string}
  businessRoulettes$: Observable<BusinessManagment[]>
  columns: { field: string; headerTranslate: string; type?: FieldTypes; width?: string;sortable?:boolean }[] = [];
  numRowsInPage = 100; 
  totalRecords: number;
  returnTotalRecords = false;
  loadBusinessRoulettesEvent$ = new BehaviorSubject(true);
  freeSearch: string;
  packageName:string;
  businessSource:SourceEnum = null;
  currentLanguage:Language;

  businessSources =[{label:"BUSINESS_MANAGEMENT.NO_SEARCH",value:0},{label:"BUSINESS_MANAGEMENT.FRONTALY",value:1},{label:"BUSINESS_MANAGEMENT.WEB",value:2}] ;
  translatedSourceOptions: { label: string; value: number }[] = [];
  packageNames: { label: string, value: number }[]
  selectedPackage: {label: string, value: number}

  constructor(public localizationService: LocalizationService,
             public store:Store<AppState>,
            public commonService: CommonService,
            public businessManagment:BusinessManagmentService) {
  
}
ngOnInit() {
  this.commonService.changeCurrentPageHeader(this.localizationService.Translate('MENU.BUSINESS_MANAGMENT')) ;
  this.store.select(selectLanguageInCommonState).subscribe(language => {
      this.currentLanguage=language
    });
  this.init()
}
init(): void {
  this.initColumns();
  this.loadPackages()
  this.createRequest();
  this.translateSources()
}
onLoadData(event) {
  this.request.Paging = event.Paging;
  this.loadBusinessRoulettes();
}

loadPackages(): void {
  this.businessManagment.getPackages().subscribe(
    (data) => {
      let noSearch=this.localizationService.Translate("BUSINESS_MANAGEMENT.ALL_PACKAGES")
      this.packageNames = [
        { label: noSearch, value: null },
        ...data.map(p => ({ label: p.PackageName, value: p.PackageId }))
      ];    },
    (error) => {
      console.error('Error fetching packages', error);
    }
  );
}

loadBusinessRoulettes(): void {
  if (!this.businessRoulettes$) {
      this.initLoadBusinessRoulettesObservable();
  } else {
      this.loadBusinessRoulettesEvent$.next(true);
  }
}
translateSources(): void {
  this.translatedSourceOptions = this.businessSources.map(option => ({
    label: this.localizationService.Translate(option.label), 
    value: option.value
  }));
}
initLoadBusinessRoulettesObservable(): void {
  this.businessRoulettes$ = this.loadBusinessRoulettesEvent$.pipe(
    switchMapTo(
      this.businessManagment.getBusinessRoulettes(this.request).pipe(
        tap(res => {
          this.totalRecords = res.TotalCount;
          if (this.totalRecords) this.returnTotalRecords = true;
        }),
        map(res =>
          {
            return res.BusinessRoulettes.map(business => {
              business.SourceName = this.getSource(business.Source);
              return business;
            });
          } )
      )
    )
  );
}


createRequest(pageNo?: number) {
  this.request = {
      Paging: {
          PageNo: pageNo ? pageNo : 1,
          NumberRowsInPage: this.numRowsInPage
      },
      Filter: {
        FreeSearch:this.freeSearch,
        Package:null, 
        BusinessSource:this.businessSource
      },
      Language:this.currentLanguage,
      SortField:null,
      SortOrder:null   
  };
  if (pageNo) {
      this.initLoadBusinessRoulettesObservable();
  }
}
onSort(event: any) {
if (event.multisortmeta && event.multisortmeta.length > 0) {
    const sortField = event.multisortmeta[0].field;
    const sortOrder = event.multisortmeta[0].order === 1 ? 'asc' : 'desc';
    this.request.SortField = sortField;
    this.request.SortOrder = sortOrder;

    this.loadBusinessRoulettes();
  }
}

filterfreeSearch() {
  this.request.Filter.FreeSearch = this.freeSearch ? this.freeSearch : null;
  this.loadBusinessRoulettes()
}
selectPackage(){
  this.request.Filter.Package = { ...this.request.Filter.Package, PackageId: this.selectedPackage?.value };
  this.loadBusinessRoulettes()
}
filterSource(){
  this.request.Filter.BusinessSource= this.businessSource?this.businessSource:null;
  this.loadBusinessRoulettes();
}
private getSource (source: number): string{
  let sourceName=""
  switch (source) {
     case 2:
      sourceName='BUSINESS_MANAGEMENT.WEB';
      break;
      default:
      sourceName= 'BUSINESS_MANAGEMENT.FRONTALY';
  }
  return this.localizationService.Translate(sourceName);
}


private initColumns() { 
  this.columns = [
      {
          field: "BusinessId",
          headerTranslate: "BUSINESS_MANAGEMENT.BUSINESS_ID",
          sortable:true
      },
      {
          field: "BusinessName",
          headerTranslate: "BUSINESS_MANAGEMENT.BUSINESS_NAME",
          sortable:true

      },
      {
          field: "CreatedDate",
          headerTranslate: "BUSINESS_MANAGEMENT.CREATED_DATE",
          type: FieldTypes.fullDate,
          sortable:true

      },
      {
          field: "BusinessPhone",
          headerTranslate: "BUSINESS_MANAGEMENT.PHONE",
          sortable:true

      },
      {
          field: "FullAddress",
          headerTranslate: "BUSINESS_MANAGEMENT.ADDRESS",
          sortable:true

      },
      {
          field: "ManagerUserName",
          headerTranslate: "BUSINESS_MANAGEMENT.MANAGER_NAME",
          sortable:true

      },
      {
          field: "ManagerEmail",
          headerTranslate: "BUSINESS_MANAGEMENT.MANAGER_EMAIL",
          sortable:true

      },
      {
        field:"SourceName",
        headerTranslate:"BUSINESS_MANAGEMENT.SOURCE",
        sortable:false
      },
      {
        field:"PackageName",
        headerTranslate:"BUSINESS_MANAGEMENT.PACKAGE_NAME",
        sortable:true
      },

      {
          field: "TotalRouletteCount",
          headerTranslate: "BUSINESS_MANAGEMENT.TOTAL_ROULETTE_COUNT",
          sortable:true

      },
      {
          field: "PurchasedRouletteCount",
          headerTranslate: "BUSINESS_MANAGEMENT.PURCHASED_ROULETTE_COUNT",
          sortable:true

      },
      {
          field: "ActivePurchasedRouletteCount",
          headerTranslate: "BUSINESS_MANAGEMENT.ACTIVE_PURCHASED_ROULETTE_COUNT",
          sortable:true

      }
  ];
}

}
